import React, { useState } from 'react';
import { useAuthStore } from '../../stores';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { NuevaFacturaFlujoModal } from '../facturas/NuevaFacturaFlujoModal';
import AIAssistant from '../AIAssistant';
import { SyncDocumentLang } from './SyncDocumentLang';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [mostrarVentaRapida, setMostrarVentaRapida] = useState(false);
  const { usuario, currentEmpresa } = useAuthStore();

  if (!usuario) {
    return <div>No autorizado</div>;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <SyncDocumentLang pais={currentEmpresa?.pais} />
      {/* Sidebar */}
      <Sidebar
        open={sidebarOpen}
        setOpen={setSidebarOpen}
        onVentaRapida={() => setMostrarVentaRapida(true)}
      />
      
      {/* Contenido principal */}
      <div className="lg:ml-64">
        {/* Header */}
        <Header onMenuClick={() => setSidebarOpen(true)} />
        
        {/* Contenido de la página */}
        <main className="py-6">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>

      {/* Venta rápida: mismo wizard que Pedidos (+ Nuevo cliente + FE opcional) */}
      {mostrarVentaRapida && (
        <NuevaFacturaFlujoModal
          open
          wizardContext="pedidos"
          onClose={() => setMostrarVentaRapida(false)}
          onCreated={async () => {
            setMostrarVentaRapida(false);
          }}
        />
      )}

      {/* AI Assistant (ChatGPT) — voice + data guardrail */}
      <AIAssistant />
    </div>
  );
};
